module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#sort",
      toString: function () {
        return this.url;
      }
    }